module.exports = __webpack_public_path__ + "media/images/icon_list/menu2-6d4df19db518b5be9b56b96a956062f2.svg";